import { Link } from "react-router-dom";
import Header from "../components/Header";

const CONTAINER = "mx-auto max-w-3xl px-6 py-16";
const H1 = "text-3xl font-semibold tracking-tight text-slate-900";
const H2 = "mt-10 text-xl font-semibold text-slate-900";
const P = "mt-3 text-sm leading-relaxed text-slate-700";

export default function LegalTerms() {
  return (
    <div className="min-h-screen bg-white" data-testid="legal-terms-page">
      <Header />
      <main className={CONTAINER}>
        <div className="mb-6 rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 text-xs text-amber-900" data-testid="legal-provisional-banner">
          <strong>Provisional version</strong> — this document is a working draft and has not
          been reviewed by counsel. Consult a licensed US attorney before commercial launch.
        </div>
        <p className="text-xs font-semibold uppercase tracking-wider text-indigo-700">Legal</p>
        <h1 className={H1}>Terms of Service</h1>
        <p className="mt-2 text-xs text-slate-500">Effective date: 07/30/2026 · Governing law: State of New York, USA</p>

        <h2 className={H2}>1. Who we are</h2>
        <p className={P}>
          Talent Junction is operated by <strong>Talent Junction, Inc.</strong>, a Delaware corporation
          with its principal place of business at 169 Madison Ave, New York, NY 10016. Contact:{" "}
          <a className="text-indigo-700 hover:underline" href="mailto:contact@talentjunction.io">contact@talentjunction.io</a>.
        </p>

        <h2 className={H2}>2. The service</h2>
        <p className={P}>
          Talent Junction is a business-to-business marketplace connecting <strong>Companies</strong>{" "}
          (Employers) that post consulting missions with <strong>IT Staffing Agencies</strong> that
          propose consultants. Talent Junction does not directly employ any consultant and is not
          party to any contract signed between a Company and an Agency.
        </p>

        <h2 className={H2}>3. Accounts and approval</h2>
        <p className={P}>
          Company and Agency accounts are subject to admin review and approval. We may refuse or
          revoke access at our sole discretion, including for suspected fraud, misuse, or breach
          of these Terms.
        </p>

        <h2 className={H2}>4. Subscription &amp; billing</h2>
        <p className={P}>
          IT staffing agencies subscribe via Stripe to unlock full access. Current pricing:
        </p>
        <ul className="mt-2 list-disc pl-5 text-sm text-slate-700 space-y-1">
          <li><strong>$290/month</strong> — cancel anytime.</li>
          <li><strong>$1,990/year</strong> — save 43% (approximately $166/month equivalent).</li>
        </ul>
        <p className={P}>
          Prices are in US dollars, exclusive of any applicable sales tax. Companies (Employers)
          use Talent Junction free of charge. New agencies receive a 14-day free trial and may
          benefit from promotional periods (e.g. the summer offer 2026), during which paywalls
          are bypassed.
        </p>

        <h2 className={H2}>5. Off-platform contracts</h2>
        <p className={P}>
          Contracts between Companies and Agencies are signed <strong>off-platform</strong>.
          Talent Junction is not a party to those contracts, does not process consultant payments,
          and does not guarantee any deliverable. Both parties are solely responsible for
          performance, invoicing, taxes, and compliance with applicable law.
        </p>

        <h2 className={H2}>6. Consultant profiles and Talent Pool</h2>
        <p className={P}>
          Agencies represent that they have obtained necessary consent from consultants before
          publishing profiles to the Talent Pool. Consultants may request removal of their profile
          at any time by contacting their agency or Talent Junction directly.
        </p>

        <h2 className={H2}>7. Acceptable use</h2>
        <p className={P}>
          You agree not to (i) scrape or bulk-download data, (ii) impersonate others, (iii) send
          unsolicited commercial messages via the platform, (iv) circumvent paywalls, or (v)
          publish false, misleading, or defamatory content.
        </p>

        <h2 className={H2}>8. Data &amp; privacy</h2>
        <p className={P}>
          Our processing of personal data is described in our{" "}
          <Link to="/legal/privacy" className="text-indigo-700 hover:underline">Privacy Policy</Link>.
          Cookies used by the platform are described in our{" "}
          <Link to="/legal/cookies" className="text-indigo-700 hover:underline">Cookie Policy</Link>.
        </p>

        <h2 className={H2}>9. Warranty disclaimer</h2>
        <p className={P}>
          The service is provided <strong>as-is</strong>, without warranties of any kind. To the
          fullest extent permitted by law, Talent Junction disclaims all implied warranties,
          including merchantability and fitness for a particular purpose.
        </p>

        <h2 className={H2}>10. Limitation of liability</h2>
        <p className={P}>
          To the fullest extent permitted by law, Talent Junction's total aggregate liability for
          any claim arising from or related to the service shall not exceed the fees paid by you
          in the twelve (12) months preceding the claim.
        </p>

        <h2 className={H2}>11. Governing law &amp; disputes</h2>
        <p className={P}>
          These Terms are governed by the laws of the State of New York, USA. Any dispute shall
          be brought before the state or federal courts located in New York County, New York.
        </p>

        <h2 className={H2}>12. Changes</h2>
        <p className={P}>
          We may update these Terms from time to time. Material changes will be notified via the
          platform or by email. Continued use after the effective date constitutes acceptance.
        </p>

        <p className="mt-10 text-xs text-slate-500">Last updated: 07/30/2026 · Provisional draft.</p>
      </main>
    </div>
  );
}
